import React from 'react';
import { ChatLamp, ChatPoweredBy } from './ChatBrand';
import launcherMicMask from '../../styles/assets/img/chat/launcher-mic-mask.png';

const micMaskStyle = {
    maskImage: `url(${launcherMicMask})`,
    WebkitMaskImage: `url(${launcherMicMask})`,
};

/**
 * Collapsed chat state: a pill docked at the bottom of the page.
 * Clicking the pill opens the chat; clicking the mic opens it straight into voice input.
 */
export default function ChatLauncher({ title, onOpen, onOpenWithVoice, className = '' }) {
    return (
        <div className={`chat-launcher ${className}`.trim()}>
            <button type="button" className="chat-launcher-main" onClick={onOpen} aria-label={`${title} - open chat`}>
                <ChatLamp />
                <span className="chat-launcher-text">
                    <span className="chat-launcher-title">{title}</span>
                    <ChatPoweredBy />
                </span>
            </button>
            <button type="button" className="chat-launcher-mic" onClick={onOpenWithVoice} aria-label="Open chat with voice input">
                <span className="chat-launcher-mic-icon" style={micMaskStyle} />
            </button>
        </div>
    );
}
